import { getErrorMessage } from "Utils/errorUtils";
import { createRequest } from "Utils/requestUtils";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  bankOperationFailed,
  fetchBankCompaniesStart,
  fetchBankCompaniesSucceeded,
  fetchInsuranceCompaniesStart,
  fetchInsuranceCompaniesSucceeded,
  fetchLeasingCompaniesStart,
  fetchLeasingCompaniesSucceeded,
  insuranceOperationFailed,
  leasingOperationFailed,
} from "./slice";

const baseCompanyApiUrl = "/open/insurance/registry/company/";
const companyTypes = {
  insurance: "INSURANCE",
  bank: "BANK",
  leasing: "LEASING",
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchInsuranceCompanies() {
  const url = `${baseCompanyApiUrl}${companyTypes.insurance}`;
  try {
    const { data } = yield call(createRequest, {
      method: "get",
      url,
    });
    yield put(fetchInsuranceCompaniesSucceeded(data));
  } catch (e) {
    yield put(
      insuranceOperationFailed(
        getErrorMessage(e, "Error fetching insurance companies"),
      ),
    );
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchBankCompanies() {
  const url = `${baseCompanyApiUrl}${companyTypes.bank}`;
  try {
    const { data } = yield call(createRequest, {
      method: "get",
      url,
    });
    yield put(fetchBankCompaniesSucceeded(data));
  } catch (e) {
    yield put(
      bankOperationFailed(getErrorMessage(e, "Error fetching bank companies")),
    );
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchLeasingCompanies() {
  const url = `${baseCompanyApiUrl}${companyTypes.leasing}`;
  try {
    const { data } = yield call(createRequest, {
      method: "get",
      url,
    });
    yield put(fetchLeasingCompaniesSucceeded(data));
  } catch (e) {
    yield put(
      leasingOperationFailed(
        getErrorMessage(e, "Error fetching leasing companies"),
      ),
    );
  }
}

export function* companiesSaga(): Generator {
  yield takeLatest(fetchInsuranceCompaniesStart, fetchInsuranceCompanies);
  yield takeLatest(fetchBankCompaniesStart, fetchBankCompanies);
  yield takeLatest(fetchLeasingCompaniesStart, fetchLeasingCompanies);
}
